import { TrashIcon } from "@xola/icons";
import { FormGroup, Label } from "@xola/ui-kit";
import clsx from "clsx";
import React from "react";
import { TimeRange } from "types";
import { TimeslotTimePicker } from "../PurchaseModification/TimeslotTimePicker";
import { SecondaryButton } from "./SecondaryButton";

export interface TimeRangeProps {
    value: Partial<TimeRange>;
    onChange: (value: Partial<TimeRange>) => void;
    onDelete?: () => void;
    showLabel?: boolean;
    errors?: { startTime?: string; endTime?: string };
    startTimeLabel?: string;
    endTimeLabel?: string;
}

export const TimeRangeSelector = ({
    value,
    onChange,
    showLabel,
    onDelete,
    errors,
    startTimeLabel = "Start Time",
    endTimeLabel = "End Time",
}: TimeRangeProps) => {
    const handleStartTimeChange = (startTime: number) => {
        onChange({ ...value, startTime });
    };

    const handleEndTimeChange = (endTime: number) => {
        onChange({ ...value, endTime });
    };

    const startLabel = errors?.startTime ? `${startTimeLabel} ${errors.startTime}` : startTimeLabel;
    const endLabel = errors?.endTime ? `${endTimeLabel} ${errors.endTime}` : endTimeLabel;

    return (
        <FormGroup className="flex items-end space-x-3">
            <div className="flex-1" data-testid="time-range-selector-start-time">
                {showLabel ? <Label className={clsx(errors?.startTime && "!text-danger")}>{startLabel}</Label> : null}

                <TimeslotTimePicker
                    value={value.startTime ?? null}
                    error={errors?.startTime}
                    onChange={handleStartTimeChange}
                />
            </div>

            <div className="flex-1" data-testid="time-range-selector-end-time">
                {showLabel ? <Label className={clsx(errors?.endTime && "!text-danger")}>{endLabel}</Label> : null}

                <TimeslotTimePicker
                    value={value.endTime ?? null}
                    error={errors?.endTime}
                    onChange={handleEndTimeChange}
                />
            </div>

            {!!onDelete && (
                <SecondaryButton data-testid="time-range-selector-delete-time" onClick={onDelete}>
                    <TrashIcon />
                </SecondaryButton>
            )}
        </FormGroup>
    );
};
